// extracted by mini-css-extract-plugin
export default {"bgMain":"style_bgMain__rG209","borderRR":"style_borderRR__CT2fm","bshadow":"style_bshadow__qs8EZ"};